import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { actions } from "store";
import { arrayIsEqual, tableColumn } from "utils";
import { ActionButton, TableList } from "components/common";


class SeoTemplatePageList extends Component {
  state = {
    columnList: ['tpl_path', 'tpl_title', 'type', 'actions'],
    columnByName: {
      tpl_path: tableColumn('Путь', 'tpl_path', {
        sorter: true,
      }),
      tpl_title: tableColumn('Тайтл', 'tpl_title', {
        sorter: true,
      }),
      type: tableColumn('Тип', 'type', {
        sorter: true,
      }),
      actions: tableColumn('', 'actions', {
        align: 'right',
        render: (val, item) => (
          <ActionButton
            actions={[{
              title: 'Редактировать', key: 'edit', icon: 'edit', action: () => this.showEditForm(item),
            }, {
              title: 'Удалить', key: 'delete', icon: 'delete', action: () => this.delete(item),
              confirm: {
                title: 'Уверены, что хотите удалить?',
                okText: 'Удалить',
                cancelText: 'Отмена'
              }
            }]}
          />
        ),
      }),
    },
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { columnList } = nextProps;
    if (columnList && !arrayIsEqual(prevState.columnList, columnList)) {
      return {
        columnList: columnList,
      }
    }
    return null;
  }

  load = ({ query, activeFilter }) => {
    this.props.actions.seoTemplatePageListLoad({ query, activeFilter });
  };

  showEditForm = (item) => {
    this.props.actions.seoTemplatePageShowEditForm({ show: true, object: item })
  };

  delete = (item) => {
    this.props.actions.seoTemplatePageDelete({ id: item.id })
  };

  render() {
    const { history, defaultFilter, activeFilter, topActions, seo_template_page } = this.props;
    const { columnList, columnByName } = this.state;

    return (
      <TableList
        history={history}
        data={seo_template_page}
        defaultFilter={defaultFilter}
        activeFilter={activeFilter}
        topActions={topActions}
        columnList={columnList}
        columnByName={columnByName}
        onLoadData={this.load}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    seo_template_page: state.seo_template_page,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.seo_template_page), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SeoTemplatePageList);